import {z} from 'zod';

import {cpfValido} from '../../utils/cpf.util';

const UFS = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG',
  'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
] as const;

export const RegisterFormSchema = z.object({
  // O arquivo fica no formulario e sobe junto com o submit. Antes o step 1
  // gravava em `avatar_url`, chave que nem existia aqui: o zod descartava e o
  // avatar nunca saia do navegador.
  avatar: z.instanceof(File).nullish(),
  avatar_preview: z.string().nullish(),
  name: z.string().refine(
    (data) => data.trim().split(' ').filter(Boolean).length > 1,
    {message: 'Você precisa preencher Nome e Sobrenome'},
  ),
  email: z.string().email('Email inválido'),
  // Sem `.default('')`: o default faz o tipo de ENTRADA do zod divergir do de
  // saida, e o resolver do react-hook-form deixa de casar com o formulario.
  phone: z
    .string()
    .refine((data) => data.replace(/\D/g, '').length === 11, {message: 'Número de telefone inválido'}),
  city: z.string().min(1, {message: 'Cidade inválida'}).nullish(),
  state: z.enum(UFS).nullish(),
  atuation_type: z.enum(['presencial', 'online', 'presencial_online'], {
    errorMap: () => ({message: 'Escolha como você atende'}),
  }),
  category: z.string().min(1, {message: 'Selecione uma área de atuação'}),
  subcategory: z.string().min(1, {message: 'Selecione uma especialidade'}),
  // Professor de dança, luta e yoga muitas vezes nao tem CREF.
  cref: z.string().max(32, {message: 'CREF muito longo'}).nullish(),
  password: z.string().min(8, {message: 'Sua senha deve ter pelo menos 8 caracteres'}),
  street: z.string().min(1, {message: 'Rua inválida'}).nullish(),
  number: z.string().nullish(),
  complement: z.string().nullish(),
  neighborhood: z.string().min(1, {message: 'Bairro inválido'}).nullish(),
  zipcode: z
    .string()
    .refine((data) => (data ?? '').replace(/\D/g, '').length === 8, {message: 'CEP inválido'}),
  // A mascara aceitava qualquer sequencia de 11 digitos.
  cpf: z.string().refine(cpfValido, {message: 'CPF inválido'}),
  latitude: z.number().nullish(),
  longitude: z.number().nullish(),
});

export type RegisterFormProps = z.infer<typeof RegisterFormSchema>;

export const StateEnum = z.enum(UFS).Values;
